import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { JSON } from 'domains/OriginGateways/Gateway'
import { Structure } from 'pages/NWPlatform/OriginGateways/Gateway'
import { originGatewaysRoute } from 'pages/NWPlatform/OriginGateways/Routing'

export const gatewayRoute = createRoute({
  getParentRoute: () => originGatewaysRoute,
  path: DynamicRouteParameterWPrefix.GATEWAY_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const gatewayLayoutRoute = createRoute({
  getParentRoute: () => gatewayRoute,
  id: 'gatewayLayout',
  component: Structure,
})

export const rawRoute = createRoute({
  getParentRoute: () => gatewayLayoutRoute,
  path: '/',
  component: JSON,
})
